import { createCustomEnum } from "./customEnum";

const InstallationOutcomeEnum = createCustomEnum({
	SuccessfulInstallation: {
		name: "successful_installation",
		value: 0,
		displayName: "Successful Installation",
	},
	MerchantCannotBeReached: {
		name: "merchant_cannot_be_reached",
		value: 1,
		displayName: "Merchant Cannot Be Reached",
	},
	StoreNotOpenYet: {
		name: "store_not_open_yet",
		value: 2,
		displayName: "Store Not Open Yet",
	},
	WentWithAnotherProcessor: {
		name: "went_with_another_processor",
		value: 3,
		displayName: "Went With Another Processor",
	},
	PendingAgent: {
		name: "pending_agent",
		value: 4,
		displayName: "Pending Agent",
	},
	EquipmentSwap: {
		name: "equipment_swap",
		value: 5,
		displayName: "Equipment Swap",
	},
	UnsupportedEquipment: {
		name: "unsupported_equipment",
		value: 6,
		displayName: "Unsupported Equipment",
	},
});

export default InstallationOutcomeEnum;
